import {
  Card,
  CardHeader,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";
import React from "react";
import useAuth from "../../../../hooks/auth";
import Page from "../../../ui/page";
import UpdatePassword from "../password/update";
import EditForm from "./edit_form";
import "./profile.css.scss";

const UserProfile = () => {
  const { user } = useAuth();

  return (
    <Page headerProps={{ icon: "user", title: "Meu perfil" }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card elevation={4}>
            <CardHeader
              disableTypography
              title="Dados pessoais"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            />

            <div className="panel-body">
              <EditForm user={user} />
            </div>
          </Card>
        </Grid>

        <UpdatePassword />

        <Grid item xs={12} md={6}>
          <Card elevation={4}>
            <CardHeader
              disableTypography
              title="Dados da conta"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            />

            <div className="panel-body">
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell>Email</TableCell>
                      <TableCell>{user.email}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Cliente</TableCell>
                      <TableCell>{user.client_name}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Último acesso em</TableCell>
                      <TableCell>{user.last_signed_in_at}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Quantidade de acessos</TableCell>
                      <TableCell>{user.sign_in_counts}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Quantidade de negociações</TableCell>
                      <TableCell>{user.total_trades || 0}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Card>
        </Grid>
      </Grid>
    </Page>
  );
};

export default UserProfile;
